
<div class="col-span-7 relative p-2 rounded-md bg-orange-900 mb-2">
    <p class="text-normal text-xs relative">{{'how_to_use_stickers' | translate}}</p>
</div>
<div class="grid grid-cols-6 gap-4">
    <div class="col-span-2">
        <div class="mt-2">
            <white-label-toggle (ngModelChange)="changeStickersStatus($event)" [(ngModel)]="stickersEnabled"
                                [label]="'enable_stickers' | translate"></white-label-toggle>
        </div>
    </div>
    <div class="col-span-4"></div>
    <div class="col-span-3 min-h-96 bg-cover relative bg-center rounded-lg">
        <div class="bg-black opacity-40 w-full h-full absolute top-0 left-0"></div>
        <div appDynamicScale
        class="col-span-3 h-96 bg-cover relative bg-center bg-[url(/assets/images/stream-screen.webp)] rounded-lg">
        <div class="bg-black opacity-40 w-full h-full absolute top-0 left-0"></div>
            @if(selectedItem){
                <white-label-sticker-ad-render class="block w-full h-full"
                [item]="selectedItem"
                ></white-label-sticker-ad-render>

            }
            <iframe [src]="'https://' + (whiteLabel.whiteLabel.originDomain + '/stream/widget/stickers') | safe: 'resourceUrl'" class="w-full h-full bg-transparent absolute top-0 left-0"></iframe>
        </div>
    </div>
    <div class="col-span-3 relative">
        @if (!stickersEnabled) {
            <div class="bg-gray-900 rounded-md opacity-70 z-10 absolute top-0 left-0 h-full w-full"></div>
        }
        <div class="relative">
            <white-label-sticker-ad-edit
                    (onSave)="saveSticker($event)"
                    (onDelete)="removeItem($event)"
                    (onCancelEdit)="cancelEdit()"
                    [currency]="whiteLabel.whiteLabel.currency"
                    [item]="selectedItem"
            ></white-label-sticker-ad-edit>
        </div>
    </div>
</div>
@if (stickersEnabled) {
    <div class="my-2">
        <white-label-copy-link label="link_for_stickers_widget" [link]="'https://' + whiteLabel.whiteLabel.originDomain + '/stream/widget/stickers'"></white-label-copy-link>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        <div>
            <h2 class="text-lg text-normal mt-8">{{ 'stickers_animation' | translate }}</h2>
            <ul role="list" class="mt-3 text-normal">
                @for(item of animations; track $index){
                    <li class="grid grid-cols-3 my-2 rounded-md hover:bg-card-hover bg-card px-4 py-4 cursor-pointer" (click)="testAnimation(item)">
                        <div class="text-left col-span-2 text-xl">
                            {{'test' | translate}} {{item.key | translate}}
                        </div>
                        <div class="text-right">
                            {{ item.value }} {{'item' | translate}}
                        </div>
                    </li>
                }
            </ul>
        </div>
        <div>
            <h2 class="text-lg font-normal">{{ 'stickers' | translate }}</h2>
            @if (stickers && stickers.length) {
                <ul role="list" class="mt-3 flex flex-wrap gap-3">
                    @for (stickerItem of stickers; track $index) {
                        <li class="w-30">
                            <app-sticker-ad-item (onEdit)="editItem($event)" (onRemove)="removeItem($event)" [item]="stickerItem"></app-sticker-ad-item>
                        </li>
                    }
                </ul>
            }
        </div>
    </div>
}

